<template>
    <div class="takers-list">
        <div class="page-title">
            <div class="title">Takers</div>
            <el-button
                v-if="shrinked"
                class="zoom-button"
                icon="el-icon-zoom-in"
                @click="focus"
            ></el-button>
        </div>

        <ns-loader
            v-show="!shrinked"
            :to-load="toLoad"
            @dataFetched="onDataFetched"
        >
            <loading-template slot="loader"></loading-template>
            <div slot="content">
                <gcmcn-filters
                    ref="gcmcn-filters"
                    :filter-values="[selectedSortType, searchFilter]"
                    @reset-filters="resetFilters"
                    @hook:mounted="computeFilterHeight"
                >
                    <dropdown
                        name="Sort"
                        :multiple="false"
                        :list="$store.getters.sortTypeList"
                        itemName="name"
                        itemValue="value"
                        :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                        @on-select-item="selectedSortType = $event"
                    ></dropdown>
                    <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
                </gcmcn-filters>
                <div
                    v-if="filteredTakers.length > 0"
                    style="overflow-y: scroll;padding-right: 3px;"
                    :style="{height: `calc(100vh - ( ${usedHeight}px)`}"
                >
                    <taker-card
                        v-for="taker in filteredTakers"
                        :key="taker.uid"
                        :taker="taker"
                        selected-taker-uid="''"
                        :display-actions="false"
                    ></taker-card>
                </div>
                <div v-else-if="relatedTakers.length > 0" class="list-empty">
                    No taker(s) match this filters.
                </div>
                <div v-else class="list-empty">
                    No taker(s).
                </div>
            </div>
        </ns-loader>
    </div>
</template>

<script>

import {
    GcmcnFilters,
    Dropdown,
    SearchFilter ,
} from 'gcmcn-common';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import LoadingTemplate from '../../partials/ns-loader-template.vue';
import TakerCard from './taker-card.vue';
import {mapGetters} from 'vuex';

export default {

    components: {
        GcmcnFilters,
        Dropdown,
        SearchFilter ,
        NsLoader,
        LoadingTemplate,
        TakerCard,
    },

    props: {
        feed: {
            required: true,
            type: Object,
        },
        focused: {
            type: Boolean,
            default: false
        }
    },

    data (){
        return {
            selectedSortType: 'asc',
            searchFilter: '',
            broadcastRight: [],
            toLoad: [{
                name: 'broadcastRight',
                model: 'broadcastRight',
                filters: {
                    feed: this.feed.uid
                }
            }],
            usedHeight: 0
        };
    },

    computed: {
        ...mapGetters([
            'windowWidth'
        ]),
        shrinked() {
            return this.windowWidth <= 1024 && this.focused === false;
        },
        relatedTakers (){
            return this.$store.getters.takers.filter((taker) => {
                return this.broadcastRight.find((br) => taker.uid === br.taker_uid);
            });
        },
        filteredTakers (){
            let takers = this.relatedTakers.slice();
            if(this.selectedSortType){
                takers.sort((a, b) => a.name.localeCompare(b.name));
                if(this.selectedSortType === 'dsc'){
                    takers.reverse();
                }
            }
            if(this.searchFilter){
                takers = takers.filter((ev) => ev.name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            return takers;
        }
    },
    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
    },
    mounted (){
        this.computeFilterHeight();
    },

    methods: {
        focus() {
            this.$emit('removeFocus', ['events_list', 'feeds_list']);
            this.$emit('setFocus', 'takers_list');
        },
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
        },
        onDataFetched (res){
            this.$set(this, 'broadcastRight', res.broadcastRight);
        }
    },
};
</script>

<style lang="scss">
.takers-list {
    .page-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .zoom-button {
            background-color: #111;
            border-color: #111;
            color: #BBB;
            padding: 5px;
            font-size: 18px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Home/taker-list.vue